import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import { Grid, Button, FormHelperText, FormControl, TextField, InputLabel, Select, MenuItem, Input } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { useStateValue } from "../../context/store";
import { REQUIRED_MESSAGE } from "../../constants";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { defaultCreateValues, typeState } from "./models";
import TitleCase from "react-title-case";
import { TextMaskCustom } from "../../pages/curriculumVitae/help";

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
  },
  columnCheckBox: {
    flexBasis: "10%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "7%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
}));

const EditLaboratory = ({regionales, closeEdit, dataId, handleClickEdit, setMessage, message,toggleForm}) => {
  const [{}, dispatch] = useStateValue();

  const schema = yup.object().shape({
    laboratoryName: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(100, "Ingrese máximo 100 caracteres")
      .matches(
        /^(([0-9a-zA-ZÑñáéíóúÁÉÍÓÔÚ()/:;.,-_])+[ ]?)*$/,
        "Ingrese un nombre de laboratorio válido"
        ),
    regional: yup.string().nullable().required(REQUIRED_MESSAGE),
    status: yup.string().nullable().required(REQUIRED_MESSAGE),
    email: yup
    .string()
    .required(REQUIRED_MESSAGE)
    .email("Ingrese un correo electrónico válido")
    .min(8, "Ingrese mínimo 8 caracteres")
    .max(80, "Ingrese máximo 80 caracteres"),
    phone: yup
    .string()
    .nullable()
    .required(REQUIRED_MESSAGE)
    .min(10, "Ingrese mínimo 10 dígitos")
    .transform((value) =>
      value
      .replace(/\(/g, "")
      .replace(/\)/g, "")
      .replace(/\-/g, "")
      .replace(/\s+/g, "")
    ),
    address: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(60, "Ingrese máximo 30 caracteres"),
  });

  const { register, handleSubmit, control, errors, setValue } =useForm({
    resolver: yupResolver(schema),
    defaultCreateValues,
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
    toggleForm();
  };

  const onSubmitEdit = (data) => {
    const filterRegional = regionales?.filter(x => x?.id === data?.regional);
    const reg = filterRegional?.map((y ) => y?.name).toString();
    const newData = {
      id: dataId?.id,
      laboratoryName: data?.laboratoryName,
      status: data?.status,
      regionalName: reg,
      regionalId: data?.regional,
      email: data?.email,
      address: data?.address,
      telephone: data.phone
      ?.replace(/\(/g, "")
      ?.replace(/\)/g, "")
      ?.replace(/\-/g, "")
      ?.replace(/\s+/g, ""),
    }
    setMessage({
      description: "¿Está seguro que desea modificar Laboratorio?",
      textButtonSubmit: "Guardar",
      handleClick: () => handleClickEdit(newData),
      handleClickOut: () => handleClickClose(),
      type: "QUESTION",
      open: true,
    });
  }

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Laboratorio",
      breadCrumbSubText: "Laboratorio",
      index: 22,
      handleSaveOrderClauses: false,
    });

    if(dataId){
      setValue("laboratoryName", dataId?.laboratoryName);
      setValue("status", dataId?.status);
      setValue("regional", dataId?.regional?.id);
      setValue("email", dataId?.email);
      setValue("phone", dataId?.telephone);
      setValue("address", dataId?.address);
    }
  }, []);
  const classes = useStyles();

  const handleUserKeyPress = (e) => {
    let invalidChars = ["-", "e", "+", "E", ".", ","];
    if (invalidChars?.includes(e.key)) {
      e.preventDefault();
    }
  };

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  return (
    <div className={classes.root}>
      <Typography style={{fontWeight: 'bold'}}>
        Información del laboratorio
      </Typography>
      <form
        className={classes.form}
        onSubmit={handleSubmit(onSubmitEdit)}
        autoComplete="off"
      >
        <Grid
          container
          spacing={2}
          style={{ paddingTop: "20px", }}
        >
          <Grid item xs={12} md={6} lg={6}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                defaultValue=""
                InputLabelProps={{ shrink: true }}
                inputRef={register}
                variant="outlined"
                className={classes.field}
                type="text"
                autoComplete="off"
                label="Nombre del laboratorio *"
                name="laboratoryName"
                size="small"
                error={
                  !!errors.hasOwnProperty("laboratoryName") &&
                  errors["laboratoryName"].message
                }
                helperText={
                  errors.hasOwnProperty("laboratoryName") &&
                  errors["laboratoryName"].message
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("status") && errors["status"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-status"
                shrink={true}
                size="small"
              >
                Estado
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                label="Estado"
                size="small"
                name="status"
                notched={true}
                defaultValue={null}
                inputProps={{
                  name: "status",
                  id: "outlined-select-status",
                }}
                as={
                  <Select>
                    {typeState.map((state) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={state}
                        value={state}
                      >
                        <TitleCase string={state} />
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("status") && errors["status"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("regional") &&
                errors["regional"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-regional"
                shrink={true}
                size="small"
              >
                Regional
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                label="Regional"
                size="small"
                name="regional"
                notched={true}
                defaultValue={null}
                inputProps={{
                  name: "regional",
                  id: "outlined-select-regional",
                }}
                as={
                  <Select>
                    <MenuItem
                      className={classes.menuItem}
                      aria-label="None"
                      value={null}
                    >
                      <em>&nbsp;</em>
                    </MenuItem>
                    {regionales.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        <TitleCase string={op.name} />
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("regional") &&
                  errors["regional"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4} lg={4}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.field}
                InputLabelProps={{ shrink: true }}
                label="Correo electrónico *"
                placeholder="ejemplo@correo.com"
                name="email"
                size="small"
                error={
                  !!errors.hasOwnProperty("email") && errors["email"].message
                }
                helperText={
                  errors.hasOwnProperty("email") && errors["email"].message
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4} lg={4}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.field}
                InputLabelProps={{ shrink: true }}
                label="Dirección *"
                name="address"
                size="small"
                error={
                   !!errors.hasOwnProperty("address") && errors["address"].message
                }
                helperText={
                   errors.hasOwnProperty("address") && errors["address"].message
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4} lg={4}>
            <FormControl
              fullWidth
              style={{ marginTop: "0px" }}
              error={
                !!errors.hasOwnProperty("phone") &&
                errors["phone"].message
              }
            >
              <InputLabel htmlFor="phone" style={{zIndex: 2, marginTop: "-7px", paddingLeft: "10px",}}>
                Teléfono
              </InputLabel>
              <Input
                id="phone"
                inputComponent={TextMaskCustom}
                variant="outlined"
                type="text"
                notched={true}
                inputRef={register}
                className={classes.formField}
                name="phone"
                style={{ marginTop: "0px" }}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "0px",
                    fontSize: 14,
                    paddingLeft: "12px",
                  },
                }}
                onKeyPress={handleUserKeyPress}
                size="small"
              />
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("phone") &&
                  errors["phone"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={1} style={{ paddingTop: "30px" }}>
          <Grid item xs={12} md={12} lg={12} style={{ textAlign: "end" }}>
            <Button
              variant="contained"
              className={classes.buttonClear}
              onClick={closeEdit}
            >
              Cancelar
            </Button>
            &nbsp;&nbsp;
            <Button
              variant="contained"
              className={classes.buttonSearch}
              type="submit"
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default EditLaboratory;
